import React from 'react';
import { useHistory } from 'react-router-dom';
import { is8DataApp } from 'frontend/src/utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CardContent from './CardContent';
import Status from '../../BuildingBlocks/Misc/Status';

const useStyles = makeStyles((theme: any) => ({
  bold: {
    fontWeight: 600,
  },
}));

export default function UserCardContent({ user }) {
  const classes = useStyles();
  const history = useHistory();
  const firstName = user['custom:first_name'];
  const lastName = user['custom:last_name'];
  const email = user['email'];
  const emailVerified = user['email_verified'];
  const is8Data = is8DataApp();

  const emailStatusEl = emailVerified ? (
    <Status status="verified" textClass={classes.bold} />
  ) : (
    <Status
      status="notVerified"
      label="Not Verified"
      textClass={classes.bold}
    />
  );
  const userAttrs = {
    name: {
      label: 'Name',
      value: `${firstName} ${lastName}`,
    },
    email: {
      label: 'Email',
      value: email,
    },
    ...(!is8Data
      ? {
          is_email_verified: {
            label: 'Email verified',
            value: emailStatusEl,
          },
        }
      : {}),
  };
  const buttonsMap = {
    edit_name: {
      id: 'edit_name',
      label: 'Change name',
      callback: () => history.push('/account/name'),
    },
    change_password: {
      id: 'change_password',
      label: 'Change password',
      callback: () => history.push('/account/change-password'),
    },
  };
  return <CardContent attributesMap={userAttrs} buttonsMap={buttonsMap} />;
}
